import { SearchResult } from 'src/app/search/search.model';

export const mockSearchResult: SearchResult = {
  content: [
    {
      ePolicyId: 1,
      productType: 'MOTOR',
      contractNo: '19-001-M01-000167',
      idCardNo: 'xxxxxxxxx9724',
      passportNo: 'xxxxxxxxx4565',
      firstName: 'test',
      lastName: 'testtest',
      expiredDate: '2020-01-29T17:00:00.000+0000',
      lastSentDate: '2019-06-20T11:05:42.000+0000',
      lastSentMobileNo: '08xxxx0088',
      lastSentMobileNoWithoutEncode: '0811220088',
      sentBy: 'pariyakornbua',
      emailTo: ['test@gmail.com'],
      pdfStatus: 'N',
      emailStatus: 'F',
      docType: 'ePolicy'
    },
    {
      ePolicyId: 2,
      productType: 'MOTOR',
      contractNo: '19-001-M02-000125',
      idCardNo: 'xxxxxxxxx9724',
      passportNo: null,
      firstName: 'หมู',
      lastName: 'อู๊ดอู๊ด',
      expiredDate: '2020-06-19T17:00:00.000+0000',
      lastSentDate: '2019-06-20T10:24:52.000+0000',
      lastSentMobileNo: '08xxxx1188',
      lastSentMobileNoWithoutEncode: '0811221188',
      sentBy: 'pariyakornbua',
      emailTo: ['tagdanai.sujinnapram@allianz.com'],
      pdfStatus: 'S',
      emailStatus: 'S',
      docType: 'ePolicy'
    }
  ],
  totalElements: 2
};
